import { render, staticRenderFns } from "./JuniorHandlerDetails.vue?vue&type=template&id=5dccc214"
import script from "./JuniorHandlerDetails.vue?vue&type=script&lang=ts"
export * from "./JuniorHandlerDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports